import { CancelToken } from 'axios';
import { IHttpResponse, serverAxios } from '../../http';
import { IImportFileNew } from 'interfaces/price';

class SearchByRefAllHttp {

  private static route = 'reliable/autocomplete/all-reference/search';
  private static searchReferenceOrder = 'reliable/autocomplete/search-with-price';
  public async SearchByRefAll(data: string, cancelToken: CancelToken): Promise<IRefDataAll> {

    return serverAxios.get(SearchByRefAllHttp.route, { params: { q: data }, cancelToken: cancelToken });
  }

  public async getPriceOrder(params: { q: string, codfou?: string }, cancelToken: CancelToken): Promise<IHttpResponse<IImportFileNew[]>> {
    return serverAxios.get(SearchByRefAllHttp.searchReferenceOrder, { params: params, cancelToken: cancelToken });
  }

}

export interface IDataRefAll {
  reference: string;
  ind_equivalence,
  source: string;
  codfou: number;
  name: string;
  supplier_id: number;
  reference_full: string;
}

export interface IRefDataAll {
  data: IDataRefAll[];
}

export default SearchByRefAllHttp;
